<template>
  <div :class="['app-content-block-text', { centered: data.centered }]" :style="styles" v-html="data.text" />
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    styles() {
      return {
        '--app-content-block-text-max-width': this.data.maxWidth || 'none',
      };
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/assets/scss/variables-site/variables' as vars;

.app-content-block-text {
  line-height: 1.5;
  overflow-wrap: break-word;

  @media (min-width: vars.$tablet-break-point) {
    max-width: var(--app-content-block-text-max-width);
    font-size: 18px;

    &.centered {
      margin-left: auto;
      margin-right: auto;
    }
  }

  ::v-deep {
    & > * + * {
      margin-block-start: 36px;
    }

    h2,
    h3,
    h4,
    h5,
    h6,
    b,
    strong {
      font-weight: 600;
    }

    h2,
    h3,
    h4,
    h5,
    h6 {
      font-size: inherit;
    }

    a {
      color: vars.$c-dark-gray;
    }
  }
}
</style>
